<template>
    <div>
        <!-- Display state if user is not yet paid -->
        <md-empty-state
            v-cloak
            v-if="isWaitingPayment && userDetails.paymentConfirm == false &&
            (userDetails.repondu == '' || userDetails.repondu == null) && !loadingUser"
            v-show="pay_success == false"
            class="md-accent"
            md-icon="error_outline"
            :md-label="$t('payment_not_received')"
            :md-description="$t('payment_not_received_text_label')">
            <button @click="payment_url" class="btn-rounded btn btn-info btn-sm ripple-parent">Continue to online payment</button>
        </md-empty-state>
        <!-- Display state if user is not yet pconfirm payment -->
        <md-empty-state
            v-cloak
            v-else-if="isWaitingPayment && userDetails.paymentConfirm == true &&
            (userDetails.repondu == '' || userDetails.repondu == null) && !loadingUser"
            v-show="pay_success == false"
            class="md-accent"
            md-icon="error_outline"
            :md-label="$t('payment_not_confirm')"
            :md-description="$t('payment_not_confirm_text_label')">
            <button @click="reload_url" class="btn-rounded btn btn-info btn-sm ripple-parent">Recommencer</button>
        </md-empty-state>
        <!-- Display state if user haven't selected his/her gender or civilty -->
        <md-empty-state
            v-cloak
            v-else-if="(userDetails.civility == '' || userDetails.civility == null) && !loadingUser"
            v-show="pay_success == false"
            class="md-accent"
            md-icon="error_outline"
            :md-label="$t('civility_not_selected')"
            :md-description="$t('civility_not_selected_text_label')">
            <localized-link to="account">{{$t('link_account_settings')}}</localized-link>
        </md-empty-state>
        <!-- Display state if user responded the comcolors profile questionnaire and talents research questionnaire -->
        <md-empty-state
            v-cloak
            v-else-if="userDetails.repondu != '' && parseInt(userDetails.research_talent_repondu) > talentsTotalQuestions && !talentSubmited"
            class="md-primary" md-icon="thumb_up"
            :md-label="$t('nothing_to_be_done')"
            :md-description="$t('nothing_to_be_done_text_label')">
        </md-empty-state>
        <!-- Display state if user responded the comcolors profile questionnaire and started answering the talents questionnaire -->
        <md-empty-state
            v-cloak
            v-else-if="(userDetails.elearningStress == '' && userDetails.elearningEnsemble == '') && talentNotCompleted && userDetails.hasTalent == true"
            class="md-primary" md-icon="done">
            <span>{{$t('talents_text_label_1')}}</span><br>
            <span>{{$t('talents_text_label_2')}}</span><br>
            <button @click="(talentMessage = true) && (totalAnswered = 0)" class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('talents_button_text')}}</button>
        </md-empty-state>
      <!-- Display state if user responded the comcolors profile questionnaire and demand to accept test questionnaire -->
        <md-empty-state
          v-cloak
          v-else-if="(userDetails.elearningStress == '' && userDetails.elearningEnsemble == '') && talentNotCompleted && userDetails.hasTalent == false && canShowDemandTest"
          class="md-primary" md-icon="done"
          :md-label="$t('your_answers_have_been_saved')"
          :md-description="savedSuccessMessage">
            <a :href="`https://www.comcolors.com/${currentLocale}/quest-ce-que-le-modele-comcolors`" target="_blank"><button class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('return_to_home')}}</button></a>
          <!--<p class="md-empty-state-description">
            {{$t('txt_intro_questionnaire_test1')}}<br>
            {{$t('txt_intro_questionnaire_test2')}}<br>
            {{$t('txt_intro_questionnaire_test3')}}<br>
          </p>
          <button @click="acceptQuestionnaireTest();" class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('yeas_i_accept')}}</button>-->
        </md-empty-state>
        <!-- Display state if user responded the comcolors profile questionnaire and thanks accept test questionnaire -->
        <md-empty-state
          v-cloak
          v-else-if="(userDetails.elearningStress == '' && userDetails.elearningEnsemble == '') && talentNotCompleted && userDetails.hasTalent == false && canShowThankTest"
          class="md-primary" md-icon="done"
          :md-label="$t('your_answers_have_been_saved')"
          :md-description="savedSuccessMessage">
            <a :href="`https://www.comcolors.com/${currentLocale}/quest-ce-que-le-modele-comcolors`" target="_blank"><button class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('return_to_home')}}</button></a>
          <!--<p class="md-empty-state-description">
            {{$t('thanks_accept_questionnaire_test')}}<br>
          </p>-->
        </md-empty-state>
        <md-empty-state
          v-cloak
          v-else-if="(userDetails.elearningStress == '' && userDetails.elearningEnsemble == '') && talentNotCompleted && userDetails.hasTalent == false && canStartTalent"
          class="md-primary" md-icon="done"
          :md-label="$t('your_answers_have_been_saved')"
          :md-description="savedSuccessMessage">
            <a :href="`https://www.comcolors.com/${currentLocale}/quest-ce-que-le-modele-comcolors`" target="_blank"><button class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('return_to_home')}}</button></a>
          <!--<p class="md-empty-state-description">
            {{$t('talents_thanks_text_1')}}<br>
            {{$t('talents_thanks_text_2')}}<br><br>
            {{$t('proceed')}}: <a href="https://questionnaire-talents.comcolors.com/" target="_blank">https://questionnaire-talents.comcolors.com/</a><br>
            <strong>{{$t('your_id_email_label')}} </strong>{{ userDetails.email }}<br>
          </p>-->
        </md-empty-state>
        <!-- Display state if user responded the comcolors profile questionnaire and not can / not accept second test questionnaire  -->
        <md-empty-state
          v-cloak
          v-else-if="(userDetails.elearningStress == '' && userDetails.elearningEnsemble == '') && talentNotCompleted && userDetails.hasTalent == false && canStartTalent == false && canAnswerQuestionnaireTest == false"
          class="md-primary" md-icon="thumb_up"
          :md-label="$t('nothing_to_be_done')"
          :md-description="$t('nothing_to_be_done_text_label')">
        </md-empty-state>
        <!-- Display state if elearning subscriber and successfully answered the questionnaire -->
        <md-empty-state
          v-cloak
          v-else-if="(userDetails.elearningStress != '' || userDetails.elearningEnsemble != '') && talentNotCompleted"
          class="md-primary" md-icon="done"
          :md-label="$t('your_answers_have_been_saved')">
          <p class="md-empty-state-description">
            {{$t('success_message_1')}}<br>
            {{$t('success_message_2')}}<br><br>
            {{$t('proceed')}}....<br>
            {{$t('proceed')}}: <a href="https://www.comcolors.com/lms" target="_blank">https://www.comcolors.com/lms</a><br>
            <strong>{{$t('your_id_email_label')}} </strong>{{ userDetails.email }}<br>
          </p>
        </md-empty-state>
        <!-- Display questionnaire with questions if user have been paid -->
        <div class="questionnaire-wrapper" v-else v-show="((submitted == false && talentMessage == false) || isAnswered == true) && !loadingUser" v-cloak>
            <breadcrumb v-show="!loading">{{$t('viewing')}}&nbsp;&nbsp;
                <breadcrumb-item><a>{{currentPage}}</a></breadcrumb-item>
                <breadcrumb-item active>{{totalPages}}</breadcrumb-item>
            </breadcrumb>
            <div class="loading-spinner-wrap" v-if="loading">
                <md-progress-spinner :md-stroke="4" md-mode="indeterminate"></md-progress-spinner>
            </div>
            <div v-for="(question,i) in arr_questions" :key="i">
                <div class="theme-libelle" v-for="(theme,index) in question.theme" :key="index" v-if="theme.locale === currentLocale">
                    {{ theme.libelle }}
                </div>
                <div class="questionnaire-item d-flex align-items-center justify-content-between" v-for="q in question.questions" :key="q.id">
                    <div class="question-item d-flex align-items-center col-xl-8 col-lg-7 col-md-6 col-sm-5">
                        <span class="index-number">{{ q.order }}</span>
                        <p v-for="(locales,index) in q.translations" :key="index" v-if="locales.locale === currentLocale">
                            <span v-if="userDetails.civility == 'Monsieur'">{{ locales.libelle_masculin }}</span>
                            <span v-else-if="userDetails.civility == 'Madame'">{{ locales.libelle_feminin == '' ? locales.libelle_masculin : locales.libelle_feminin }}</span>
                            <span v-else>Please select preferred civility to display questions</span>
                        </p>
                    </div>
                    <choices class="col-xl-4 col-lg-5 col-md-6 col-sm-7" :response="q" :order="q.order" @counter="count" @status="state" :currentLocale="currentLocale" :ifResearchQuestionnaire="isAnswered && canStartTalent" :isTestQuestionnaire="canAnswerQuestionnaireTest"  :civility="userDetails.civility" />
                </div>
            </div>
            <br>
            <button v-show="!loading && page != totalPages && totalAnswered == currentLength" :disabled="page >= totalPages" @click="nextPage" class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('next')}}</button>
            <button v-show="page == totalPages && totalAnswered == currentLength" @click="submitAnswers" class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('submit_answers')}}</button>
        </div>
        <!-- Display state if successfully answered the questionnaire and not propose talents questionnaire-->
        <md-empty-state
            v-if="userDetails.elearningStress == '' && userDetails.elearningEnsemble == ''"
            v-show="submitted == true && talentsSuccessMessage == false && hasSubmitAnsweredProfile == false"
            class="md-primary" md-icon="done"
            :md-label="$t('your_answers_have_been_saved')"
            :md-description="savedSuccessMessage">
            <a :href="`https://www.comcolors.com/${currentLocale}/quest-ce-que-le-modele-comcolors`" target="_blank"><button class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('return_to_home')}}</button></a>
        </md-empty-state>
        <!-- Display state if elearning subscriber and successfully answered the questionnaire -->
        <md-empty-state
            v-else
            v-show="submitted == true && talentsSuccessMessage == false && hasSubmitAnsweredProfile == false"
            class="md-primary" md-icon="done"
            :md-label="$t('your_answers_have_been_saved')">
            <p class="md-empty-state-description">
                {{$t('success_message_1')}}<br>
                {{$t('success_message_2')}}<br><br>
                {{$t('proceed')}}....<br>
                {{$t('proceed')}}: <a href="https://www.comcolors.com/lms" target="_blank">https://www.comcolors.com/lms</a><br>
                <strong>{{$t('your_id_email_label')}} </strong>{{ userDetails.email }}<br>
            </p>
        </md-empty-state>
        <!-- Display Talents questionnaire instruction message -->
        <md-empty-state
            v-show="talentMessage == true && talentsSuccessMessage == false"
            class="md-empty-state-description mx-auto">
            <p>{{$t('talents_text_label_3')}}</p>
            <p>{{$t('talents_text_label_4')}}</p>
            <p>{{$t('talents_text_label_5')}}</p>
            <p>{{$t('talents_text_label_6')}}</p>
            <p>{{$t('talents_text_label_7')}}</p>
            <button @click="getTalentQuestions" class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('continue_to_questionnaire')}}</button>
        </md-empty-state>
        <!-- Display state if user paid the bill successfully -->
        <md-empty-state
            v-if="pay_success == true"
            class="md-primary" md-icon="done"
            :md-label="$t('payment_sent')"
            :md-description="$t('payment_sent_text_label')">
            <button @click="questionnaire_instructions" class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('continue_to_questionnaire')}}</button>
        </md-empty-state>
        <!-- Display state if user answered the talents research questionnaire successfully -->
        <md-empty-state
            v-if="talentSubmited"
            class="md-primary" md-icon="done"
            :md-label="$t('your_answers_have_been_saved_talent')"><br>
            <a :href="`https://www.comcolors.com/${currentLocale}/quest-ce-que-le-modele-comcolors`" target="_blank"><button class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('return_to_home')}}</button></a>
        </md-empty-state>
    </div>
</template>

<script>
import axios from 'axios'
import { Breadcrumb, BreadcrumbItem } from 'mdbvue'
import Choices from '@/components/Question'
import { QUESTIONNAIRE_API, BASE_API } from '../helpers/base'
import LocalizedLink from '@/components/Menu';
import { getLoggedUser, isTalentApp, getBillTalent, getBillColor, hasColor, hasTalent, isVenteApp, saveAcceptTest } from '../services/User.service'
import { getQuestionnaire, postOverAllResponse, getQuestionResponse, postResearchRespondDate, getResearchQuestionResponse } from '../services/Questionnaire.service'
import { mapGetters, mapActions } from 'vuex'
import Vue from 'vue'
import VueStripeCheckout from 'vue-stripe-checkout'

const options = {
    //key: 'pk_live_tdDDwFPENXWmPXShzUfG9CgO',
    key: process.env.STRIPE_KEY,
    image: 'https://www.comcolors.com/public/images/Bleu-bleu.jpg',
    locale: 'auto',
    currency: 'EUR',
    billingAddress: true,
    panelLabel: 'Pay {{amount}}'
}
Vue.use(VueStripeCheckout, options);

export default {
    name: 'Questionnaire',
    components: { Choices, Breadcrumb, BreadcrumbItem, LocalizedLink },
    data(){
        return {
            questions: [],
            questionnaireId: 6,
            loading: false,
            loadingUser: true,
            page: 1,
            currentPage: 0,
            totalPages: 0,
            perPages: 10,
            totalAnswered: 0,
            active: false,
            submitted: false,
            pay_success: false,
            userDetails: {
                email: '',
                password: '',
                paye: '',
                repondu: '',
                repondu_test: '',
                type_client: '',
                totalBill: 0,
                civility: '',
                elearningStress: '',
                elearningEnsemble: '',
                research_talent_repondu: '',
                paymentConfirm: false,
                canAnswerTest: false,
                hasAcceptTest: false,
                hasAcceptTestDate: '',
                hasColor: false,
                hasTalent: false
            },
            isAnswered: false,
            hasSubmitAnsweredProfile: false,
            hasFlagAccepted: false,
            talentMessage: false,
            submitTalentsAnswer: false,
            talentsSuccessMessage: false,
            savedSuccessMessage: this.$t('your_answers_have_been_saved_coaching'),
            //talentsTotalQuestions: 165
            //talentsTotalQuestions: 181
            //talentsTotalQuestions: 120
            //talentsTotalQuestions: 173
            talentsTotalQuestions: 121
        };
    },
    methods:{
        ...mapActions(['setUserDetails']),
        async getQuestions() {
            this.loading = true;
            this.totalAnswered = 0
            try {
                let apiUse = `${QUESTIONNAIRE_API}/questionnaire/${this.questionnaireId}/questions/${this.currentUser.civilite}?page=${this.page}`;
                if (this.questionnaireId == 6) {
                  apiUse = `${BASE_API}/questionnaire/${this.questionnaireId}/questions/${this.currentUser.civilite}?page=${this.page}`;
                }
                let response = await fetch(apiUse);
                let json = await response.json();
                this.currentPage = json.questions.current_page;
                this.totalPages = json.questions.last_page;
                this.perPages = json.questions.per_page;
                this.questions = json.questions.data;
                this.loading = false;
                console.log("Questions: ", Object.assign({}, this.questions))
                console.log('API: ', response)
            }
            catch(err) {

            }
        },
        getTalentQuestions(){
            this.totalAnswered = 0;
            this.submitted = false;
            this.talentMessage = false;
            this.isAnswered = true;
            this.submitTalentsAnswer = true;
            //this.questionnaireId = 14;
            //this.questionnaireId = 5;
            //this.questionnaireId = 15;
            this.questionnaireId = 17;
            this.getQuestions();
        },
        submitAnswers(){
            this.loading = true;
            this.isAnswered = false;

            if(this.submitTalentsAnswer == true){ //Submit talents research date answered
                this.talentMessage = true;
                this.isAnswered = false;
                this.talentsSuccessMessage = true;
                this.submitted = true;
                this.loading = false;
                let data = {
                    userId: localStorage.getItem('userId'),
                    isResearchQuestionnaireEnabled: true
                }
                localStorage.removeItem('talent_answers_'+data.userId);
                postResearchRespondDate(data).then(resp => {
                    this.userDetails.research_talent_repondu = resp.data.date_answered;
                    //this.hasSubmitAnsweredProfile = true;

                    console.log(resp.data);
                }).catch(error => {
                    console.log(error);
                });
            }else{
              let origin = isTalentApp() ? 'talent' : null
              origin = isVenteApp() ? 'vente' : origin

                let data = {
                    userId: localStorage.getItem('userId'),
                    locale: this.currentLocale,
                    origin: origin
                }
                if (this.canAnswerQuestionnaireTest) {
                  data.isQuestionnaireTest = 1
                }
                localStorage.removeItem('answers_'+data.userId);
                postOverAllResponse(data).then(resp => {
                    if (isVenteApp()) {
                      this.$router.push({name:'BalanceSheetSale'});
                    }
                    if (this.canAnswerQuestionnaireTest) {
                      this.userDetails.repondu_test = Date.now();
                    }
                    this.submitted = true;
                    this.loading = false;
                    this.userDetails.repondu = resp.data.user_repondu;
                    this.hasSubmitAnsweredProfile = true;

                    // reset questionnaire talents page
                    this.page = 1;
                    console.log(resp.data);
                }).catch(error => {
                    console.log(error);
                });
            }
        },
        nextPage(){
            this.totalAnswered = 0;
            this.page++;
            this.backToTop();
            this.getQuestions();
            if(this.isAnswered == true){
                this.totalAnswered = 0;
                this.getTalentQuestions();
            }
        },
        count(value){
            if(this.totalAnswered != this.currentLength){
                this.totalAnswered += value;
            }
        },
        state(stat){
            this.active = stat;
            if(this.talentMessage == true){
                this.totalAnswered = 0
            }
            //console.log(stat);
        },
        getUserData(){
            if(localStorage.getItem('userId')) {
                this.loadingUser = true;
                const userId=localStorage.getItem('userId');
                getLoggedUser(userId).then(response => {
                    const userData = response.data.user_info
                    this.setUserDetails(userData);
                    this.userDetails.email = userData.email
                    this.userDetails.repondu = userData.questionnaire_repondu.repondu
                    this.userDetails.repondu_test = userData.questionnaire_repondu.repondu_test
                    this.userDetails.paye = userData.paye
                    this.userDetails.type_client = userData.relation_groupe.type_client
                    this.userDetails.totalBill = this.getTotalBill(userData)
                    this.userDetails.civility = userData.civilite
                    this.userDetails.elearningStress = userData.questionnaire_repondu.elearningstress
                    this.userDetails.elearningEnsemble = userData.questionnaire_repondu.elearningensemble
                    this.userDetails.research_talent_repondu = userData.research_respond_date
                    this.userDetails.paymentConfirm = userData.payment_confirm
                    this.userDetails.canAnswerTest = userData.can_answer_test
                    this.userDetails.hasAcceptTest = userData.has_accept_test
                    this.userDetails.hasAcceptTestDate = userData.has_accept_test_date
                    this.userDetails.hasColor = hasColor(userData)
                    this.userDetails.hasTalent = hasTalent(userData)
                    this.hasFlagAccepted = localStorage.getItem('hasFlagAccepted') ? true : false;
                    // User dans Membre du site different message de remerçiement
                    this.savedSuccessMessage = userData.relation_groupe.id == 1 ? this.$t('your_answers_have_been_saved_sending_profil') : this.savedSuccessMessage
                    console.log('UserData Questionnaire: ', userData)
                    this.loadingUser = false;
                }).catch(error => {
                    console.log(error.response);
                    this.loadingUser = false;
                })
            }
        },
        backToTop(){
            $('html,body').stop().animate({
                scrollTop: 0
            }, 'slow', 'swing');
        },
        payment_url(){
            this.$router.push({name:'Payment'});
        },
        reload_url(){
            this.$router.push({name:'QuestionnaireInstructions'});
        },
        questionnaire_instructions(){
            this.$router.push({name:'QuestionnaireInstructions'});
        },
        async getUnAnsweredQuestions(){
            const userId = localStorage.getItem('userId');
            let currentPage = 0
            this.totalAnswered = 0
            let ifQuestionnaireTest = (this.currentUser.repondu && this.currentUser.date_relance != null && this.currentUser.questionnaire_repondu.repondu_test == null);

            if(this.currentUser.repondu && !ifQuestionnaireTest){ //If 1st questionnaire has been completed then enable 2nd questionnaire
                getResearchQuestionResponse(userId).then(resp => {
                    localStorage.setItem('talent_answers_'+userId, JSON.stringify(resp.data.answers));
                    const user_answer = resp.data.answers;
                    const totalAnswered = user_answer.length
                    if(currentPage >= this.totalPages){
                        currentPage = parseInt(totalAnswered / this.perPages)
                    }else{
                        currentPage = parseInt(totalAnswered / this.perPages) + 1
                    }
                    if(currentPage !== this.page){
                        this.page = currentPage
                        this.totalAnswered = 0
                        this.getQuestions();
                    }
                    console.log("Current page: ", currentPage);
                }).catch(error => {
                    console.log(error);
                });
            } else { //Default questionnaire will be 1st questionnaire
                getQuestionResponse(userId).then(resp => {
                    localStorage.setItem('answers_'+userId, JSON.stringify(resp.data.answers));
                    const user_answer = resp.data.answers;
                    const totalAnswered = user_answer.length
                    if(currentPage >= this.totalPages){
                        currentPage = parseInt(totalAnswered / this.perPages)
                    }else{
                        currentPage = parseInt(totalAnswered / this.perPages) + 1
                    }
                    if(currentPage !== this.page){
                        this.page = currentPage
                        this.totalAnswered = 0
                        this.getQuestions();
                    }
                    console.log("Current page: ", currentPage);
                }).catch(error => {
                    console.log(error);
                });
            }
        },
        getTotalBill(userInfo){
          let totalAmount = 0;
          // je suis dans l'application talents
          if (isTalentApp()) {
            totalAmount = getBillTalent(userInfo)
          // je suis dans l'application couleurs
          } else {
            totalAmount = getBillColor(userInfo)
          }
          return totalAmount;
        },
        acceptQuestionnaireTest(){
          let data = {
            accept_test: 1
          }
          if(localStorage.getItem('userId')) {
            this.loading = true;
            saveAcceptTest(localStorage.getItem('userId'), data).then(resp => {
              this.userDetails.hasAcceptTest = true;
              this.hasFlagAccepted = true;
              localStorage.setItem('hasFlagAccepted', 1);
              this.loading = false;
            }).catch(error => {
              console.log(error);
            });
          }
        }
    },
    computed:{
        ...mapGetters(['currentUser']),
        currentLocale() {
            return this.$route.params.locale
        },
        currentLength(){
            const obj = Object.keys(this.questions)
            return obj.length;
        },
        arr_questions(){
            let data = this.questions
            const grouped = _(data)
            .groupBy(x => x.group.libelle)
            .map((value, index) => ({
                theme: value[0].group.translations,
                questions: value
            }))
            .value();
            console.log("Result: ", grouped);
            return grouped;
        },
        isWaitingPayment(){
          let isWaiting = false;
          isWaiting = (this.userDetails.paye == '' || this.userDetails.paye == null);
          // Dans le cas ou le questionnaire vente est gratuit
          if (parseInt(this.userDetails.totalBill)<= 0)
              isWaiting = false;

          return isWaiting;
        },
        talentNotCompleted(){
          return ((this.userDetails.repondu != '' && this.userDetails.research_talent_repondu == '' && this.isAnswered == false && this.talentMessage == false) || (this.hasSubmitAnsweredProfile == true && this.userDetails.research_talent_repondu == '' && this.isAnswered == false && this.talentMessage == false)  || (this.userDetails.repondu != '' && parseInt(this.userDetails.research_talent_repondu) <= this.talentsTotalQuestions && this.isAnswered == false && this.talentMessage == false));
        },
        talentSubmited(){
          return (this.submitted == true && this.talentsSuccessMessage == true);
        },
        canStartTalent(){
          return (this.userDetails.hasAcceptTest == true && this.userDetails.repondu_test != '' && this.userDetails.repondu_test != null);
        },
        canShowDemandTest(){
          return (this.userDetails.canAnswerTest == true && this.userDetails.hasAcceptTest == false);
        },
        canAnswerQuestionnaireTest(){
          return (this.userDetails.hasAcceptTest == true && this.userDetails.hasAcceptTestDate != '' && (this.userDetails.repondu_test == '' || this.userDetails.repondu_test == null));
        },
        canShowThankTest(){
          return (this.userDetails.hasAcceptTest == true && this.userDetails.hasAcceptTestDate == '');
        }

    },
    watch: {
        '$route': ['getUserData']
    },
    async mounted(){
        this.getUserData();
        await this.getQuestions();
        await this.getUnAnsweredQuestions();
    }
}
</script>

<style scoped>
[v-cloak] {
display: none;
}
.questionnaire-wrapper {
position: relative;
}
.questionnaire-item {
background-color: #f9f9f9;
border-bottom: 1px solid #dadada;
}
.questionnaire-item:hover {
background-color: rgba(51, 181, 229, 0.12)
}
.questionnaire-item p {
text-align: left;
margin-bottom: 0;
padding: 10px 0 10px 15px;
font-size: 16px !important;
}
.questionnaire-item span.index-number {
background: #33b5e5;
color: #fff;
padding: 3px 10px 3px 10px;
}
.loading-spinner-wrap {
position: fixed;
width: 100%;
left: 0;
right: 0;
top: 0;
bottom: 0;
background-color: rgba(255,255,255,0.7);
z-index: 99999;
}
.loading-spinner-wrap .md-progress-spinner {
height: 100%;
justify-content: center;
align-items: center;
}
.questionnaire-wrapper ol.breadcrumb {
background-color: #eaeaea;
justify-content: flex-end;
font-weight: 600;
}
.answered {
border-right: 3px solid #33b5e5
}
.theme-libelle {
padding: 25px 15px 25px 15px;
background: #eaeaea;
font-weight: 600;
text-align: center;
font-size: 4vmin !important;
border: 2px solid black;
}
.md-empty-state {
padding: 0;
}
.hr-text {
line-height: 1em;
position: relative;
outline: 0;
border: 0;
color: black;
text-align: center;
height: 1.5em;
opacity: .5;
}
.hr-text:before {
content: '';
background: linear-gradient(to right, transparent, #818078, transparent);
position: absolute;
left: 0;
top: 50%;
width: 100%;
height: 1px;
}
.hr-text:after {
content: attr(data-content);
position: relative;
display: inline-block;
color: black;
padding: 0 .5em;
line-height: 1.5em;
color: #818078;
background-color: #fcfcfa;
}
@media (max-width: 580px){
.questionnaire-item {
flex-direction: column;
}
.question-item p {
text-align: justify;
}
.question-item,
.choices-wrap {
-ms-flex: 0 0 100%;
-webkit-box-flex: 0;
flex: 0 0 100%;
max-width: 100%;
}
}
@media (max-width: 420px) {
  .theme-libelle {
    font-size: 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Questionnaire.vue